export default __webpack_public_path__ + "static/media/pic (5).ab0f214d.jpg";